import styled, { css } from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { desktop } from 'core/components/Form/formStyles';

export const Wrapper = styled.div`
	background-color: ${getColor('whisper')};
	padding: 32px 0;
	position: relative;
	overflow: hidden;
	${desktop`
		padding: 130px 0;
		background-image: linear-gradient(
			160deg,
			${getColor('whisper')} 60%,
			${getColor('blueHaze')} 60%
		);
	`}
`;

export const SwirlWrapper = styled.div`
	position: absolute;
	bottom: 40px;
	right: -20px;
	opacity: 0.5;

	${desktop`
		right: 0;

		svg {
			width: 220px;
			height: 123px;
		}
	`}
`;
